import 'reflect-metadata';

// Die Communications der Module registriert der Lader, wenn ein Modul zum ersten Mal geoeffnet wird
// (lib/module-loader.ts).

export * from './manager/state-manager';
export * from './observer/observer';

import { injectStylesheets } from '@dh-software/furnview-icons';
injectStylesheets(true);
import '@dh-software/dh-components-themes/defines/orange-light.css';
import '@dh-software/dh-components-themes/styles.css';
import '@dh-software/dh-components';

export * from './dh-furnhome/dh-furnhome';
